<template>
  <!-- 图文导航组件库 -->
  <div
    style="position: relative"
    class="graphicnavigation"
    :style="{ backgroundImage: 'url(' + datas.bgImg + ')' }"
  >
    <div v-if="!isShow" :class="{ 'mask': !isShow }">已隐藏</div>
    <!-- 组件库左侧名称 -->
    <slot name="name" />
    <!-- 默认导航 -->
    <section
      class="defaultNavigation"
      v-if="!datas.imageList[0]"
      :style="{
        background: datas.backgroundColor,
        display: datas.imgStyle === 0 ? 'flex' : '-webkit-box',
        'overflow-x': datas.imgStyle === 0 ? '' : 'scroll',
      }"
    >
      <!-- 导航 -->
      <div
        class="navigationList"
        v-for="index in 5"
        :key="index"
        :style="{
          width:
            datas.imgStyle === 0 ? 'auto' : 375 / datas.showSize - 1 + 'px',
        }"
        @click="handleNavigationClick({ index, text: '导航', type: 'default' })"
      >
        <!-- 图片 -->
        <img
          src="@/assets/images/imgs.png"
          alt="默认图片"
          v-show="datas.navigationType === 0"
          draggable="false"
          :style="{ 'border-radius': datas.borderRadius + '%' }"
        />
        <!-- 文字 -->
        <p :style="{ color: datas.textColor }">导航111</p>
      </div>
    </section>

    <!-- 导航列表 -->
    <section
      class="defaultNavigation"
      v-else
      :style="{
        background: datas.backgroundColor,
        display: datas.imgStyle === 0 ? 'flex' : '-webkit-box',
        'flex-wrap': datas.imgStyle === 0 ? 'wrap' : 'nowrap',
        'justify-content':
          datas.imgStyle === 0 ? 'space-evenly' : 'space-around',
        'overflow-x': datas.imgStyle === 0 ? '' : 'scroll',
      }"
    >
      <!-- 导航 -->
      <div
        class="navigationList"
        v-for="(item, index) in datas.imageList"
        :key="index"
        :style="{
          width: datas.imgStyle === 0 ? '20%' : 375 / datas.showSize - 1 + 'px',
        }"
        @click="handleNavigationClick({ index, item, type: 'custom' })"
      >
        <!-- 图片 -->
        <img
          :src="item.src"
          alt="默认图片"
          v-show="datas.navigationType === 0"
          draggable="false"
          :style="{ 'border-radius': datas.borderRadius + '%' }"
        />
        <!-- 文字 -->
        <p
          :style="{
            color: datas.textColor,
            'font-size': datas.textSize + 'px',
            height: datas.textHeight + 'px',
            'line-height': datas.textHeight + 'px',
          }"
        >
          {{ item.text }}
        </p>
      </div>
    </section>

    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
export default {
  name: "graphicnavigation",
  props: {
    datas: Object,
    isShow: Boolean,
  },
  created() {
    console.log(this.datas, "--------graphicnavigation");
  },
  mounted() {
    // 为每个导航项生成pageId
    if (this.datas && this.datas.imageList && this.datas.imageList.length > 0) {
      this.datas.imageList.forEach((item, index) => {
        // 也为每个导航项添加唯一的id
        if (!item.id) {
          item.id = this.$utils.customIDChild(this.datas.id, index);
        }
      });
    }
  },
  methods: {
    // 处理导航项点击事件
    handleNavigationClick(params) {
      console.log("导航项点击了", params, params.item);
      if (!params.item.linktype) {
        console.log("没有linktype", params, params.item.linktype);
        this.$message.error("请选择跳转方式");
        return;
      } else if (params.item.linktype == 10) {
        //内部跳转
        if (params.item && params.item.http && params.item.http.internalLink) {
          this.$router.push({
            path: "/productOpenwecartAfter/admin/Edit",
            query: {
              pageId: params.item.http.internalLink,
            },
          });
        }
        console.log("导航项内部跳转被点击了:", params);
        return false;
      } else if (params.item.linktype == 11) {
        //外部跳转
        let url = params.item.http.externalLink.trim();
        if (!/^https?:\/\//.test(url)) url = "https://" + url;
        window.open(url, "_blank"); // 外部链接新窗口打开
        console.log("导航项被点击外部跳转了:", params, url);

        return false;
      }

      // 触发自定义事件，通知父组件
      this.$emit("navigation-click", params);
    },
  },
};
</script>

<style scoped lang="scss">
.graphicnavigation {
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  /* 默认导航 */
  .defaultNavigation {
    // overflow-x: scroll;
    justify-content: space-evenly;
    &::-webkit-scrollbar {
      height: 1px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #155bd4;
    }
    ::v-deep.el-collapse-item__header,
    ::v-deep.el-collapse-item__wrap {
      border-bottom: 0 !important;
    }
    /* 导航 */
    .navigationList {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        margin-top: 5px;
        width: 45px;
        height: 45px;
      }
      p {
        font-size: 12px;
        margin-top: 5px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        box-sizing: border-box;
      }
    }
  }
}
</style>
